import liabilities from './co-liabilities'
import taxRegimes from './co-tax-regimes'

export const coLiabilities = liabilities
export const coTaxRegimes = taxRegimes
